import { ShoeSize } from '~/features/size/size';
import { getFootSizeByFootSizeEnum } from '~/features/status/interfaces/foot';
import type { Status } from '~/features/status/interfaces/models';
import type { DateTimeString } from '~/interfaces/common';
import { unixTimeFromSQL } from '~/utils/time';

interface StatusData {
  date: DateTimeString;
  right_length: number; // 右足足長
  right_circumference: number; // 右足足囲
  right_shoe_width?: number; // 右足国際規格サイズ
  left_length: number; // 左足足長
  left_circumference: number; // 左足足囲
  left_shoe_width?: number; // 左足国際規格サイズ
  height: number; // 身長
  weight: number; // 体重
}

export const statusAdapter = (data: StatusData): Status => {
  const status = {
    date: unixTimeFromSQL(data.date),
    right_length: new ShoeSize(data.right_length),
    right_circumference: new ShoeSize(data.right_circumference),
    left_length: new ShoeSize(data.left_length),
    left_circumference: new ShoeSize(data.left_circumference),
    height: data.height,
    weight: data.weight,
    right_width: data.right_shoe_width
      ? getFootSizeByFootSizeEnum(data.right_shoe_width)
      : undefined,
    left_width: data.left_shoe_width ? getFootSizeByFootSizeEnum(data.left_shoe_width) : undefined,
  };

  return status;
};
